
import styled from 'styled-components'

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.text.body};
  font-family: ${({ theme }) => theme.typography.body.text.fontFamily};
  font-size: ${({ theme }) => theme.typography.body.text.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.text.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.text.lineHeight};
`

Wrapper.displayName = 'QuoteTOSWrapper'

export const Link = styled.a`
  cursor: pointer;
  text-decoration: underline;

  :hover {
    color: ${({ theme }) => theme.colors.main.hover};
  }
`

Link.displayName = 'QuoteTOSLink'
